<template>
  <section class="c-section c-section--recovery-renew my-5 py-5">
    <div class="container">
      <transition name="fade" mode="out-in">
        <div v-if="!isSent" key="send" class="c-recovery-renew">
          <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6">
              <h2 class="fs-35 sec-medium w-regular mb-5 text-center">
                Reestablecer contraseña
              </h2>
              <p class="fs-21 sec-medium w-light mb-4 text-center">
                Te enviaremos instrucciones a tu correo electrónico
                de registro para restablecer tu contraseña
              </p>

              <Alert v-if="error" type="danger" :message.sync="error"/>

              <form @submit.prevent="sendInstructions()" action="">
                <div
                  class="c-form-group mb-4"
                  :class="{ 'c-form-group--error': $v.email.$error }"
                >
                  <input
                    type="email"
                    class="c-form-group__input"
                    v-model.trim="$v.email.$model"
                    placeholder="Ingresa tu correo"
                  />

                  <div class="c-form-group__error" v-if="!$v.email.required">
                    Email requerido
                  </div>
                  <div class="c-form-group__error" v-if="!$v.email.alpha">
                    El email ingresado es incorrecto
                  </div>
                </div>
                <button
                  class="c-button c-button--primary w-100 d-flex justify-content-center"
                  :class="{'loading' : isLoading}"
                  :disabled="isLoading"
                >
                  Enviar
                  <span class="c-button__spinner ms-2">
                    <Icon icon="eos-icons:loading" />
                  </span>
                </button>
              </form>
            </div>
          </div>
        </div>

        <section v-else key="send-message">
          <div class="row justify-content-center">
            <div class="col-12 col-md-8 col-lg-6">
              <h2 class="text-center fs-35 w-regular sec-medium mb-4">
                ¡Listo!
              </h2>

              <p class="text-center fs-21 sec-medium mb-5">
                Te acabamos de enviar un correo con las instrucciones a
                <span class="w-sbold pri-color">
                  {{email}}
                </span>
                Sigue las instrucciones para restablecer tu contraseña.
              </p>
              <div class="d-flex justify-content-center">
                <a href="/?auth=login" class="c-button c-button--primary px-5">
                  Iniciar sesión
                </a>
              </div>
            </div>
          </div>
        </section>
      </transition>
    </div>
  </section>
</template>

<script>
import {
  required,
  helpers,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      email: '',

      isLoading: false,
      isSent: false,

      error: '',
    };
  },
  components: {
    Alert: () => import(/* webpackChunkName: "ui-alert" */'../../components/ui/Alert.vue'),
  },
  validations: {
    email: {
      required,
      alpha: helpers.regex('alpha', /.+@.+\..+/),
    },
  },
  methods: {
    sendInstructions() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const request = `${process.env.VUE_APP_API}/users/auth/recovery/instructions`;
        const formData = new FormData();

        formData.append('email', this.email);

        this.isLoading = true;

        fetch(request, {
          method: 'POST',
          body: formData,
        })
          .then((res) => {
            if (res.status === 201 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((response) => {
            if (response.status) {
              this.isSent = true;
            } else {
              this.error = response.message;
            }
          })
          .catch((error) => {
            let errorMessage = '';

            try {
              errorMessage = JSON.parse(error.message)?.message;
            } catch (err) {
              errorMessage = error.message;
            }

            this.error = errorMessage;
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
